"use client";
import { GlobalContext } from "@/context";
import { useContext } from "react";
import { toast } from "react-toastify";


const CommandeStatus = () => {
  const { panierStatus, setPanierStatus } = useContext(GlobalContext);

  const navigateToPaymentMethod = () => {
    if(JSON.parse(localStorage.getItem("adressId")))
        {setPanierStatus(3)}
    else {
        toast.error("Vous devez remplir votre adresse avant de passer à l'étape suivante.")  
    }
  }
  return (
    <div className="w-[60%] h-full mx-auto flex flex-col gap-1 mt-[157px] mb-14">
      <div className="flex text-[13px] lg:text-[25px] font-semibold justify-between">
        <h1>Mon panier</h1>
        <h1>Livraison</h1>
        <h1>Paiement</h1>
      </div>
      <div className="flex items-center px-1 lg:px-6">
        <div
          onClick={() => setPanierStatus(1)}
          className={`cursor-pointer min-w-[33px] h-[33px] lg:min-w-[87px] lg:h-[87px]  rounded-full flex justify-center items-center text-2xl lg:text-5xl font-semibold  border-[1px] border-[#707070] ${
            panierStatus == 1
              ? "bg-[#FF0000] text-white"
              : "text-[#FF0000] bg-white"
          }`}
        >
          1
        </div>
        <div className="h-1 w-full bg-black"></div>
        <div
          onClick={() => setPanierStatus(2)}
          className={`cursor-pointer min-w-[33px] h-[33px] lg:min-w-[87px] lg:h-[87px]  rounded-full flex justify-center items-center text-2xl lg:text-5xl font-semibold  border-[1px] border-[#707070] ${
            panierStatus == 2
              ? "bg-[#FF0000] text-white"
              : "text-[#FF0000] bg-white"
          }`}
        >
          2
        </div>
        <div className="h-1 w-full   bg-black"></div>
        <div
          onClick={navigateToPaymentMethod}
          className={`cursor-pointer min-w-[33px] h-[33px] lg:min-w-[87px] lg:h-[87px] rounded-full flex justify-center items-center text-2xl lg:text-5xl font-semibold  border-[1px] border-[#707070] ${
            panierStatus == 3
              ? "bg-[#FF0000] text-white"
              : "text-[#FF0000] bg-white"
          }`}
        >
          3
        </div>
      </div>
    </div>
  );
};
export default CommandeStatus;
